import { useSnapshotSpec } from '@flipster/features/src/shared/snapshot/use-snapshot-spec';
import { FormattedMessage } from '@flipster/i18n';
import InformationCircleIcon from '@flipster/react/icon/generated/InformationCircleIcon';
import { center } from '@flipster/styled-system/patterns';
import { QuoteCurrencyList } from '@flipster/utils/constants/currency';

interface Props {
  stakingCurrency: string;
}
const StakingCurrencyTradabilityInfo = ({ stakingCurrency }: Props) => {
  const { currenciesKeyByCurrency } = useSnapshotSpec();

  const isQuoteCurrency = QuoteCurrencyList.includes(stakingCurrency);
  const isCollateralAvailable = currenciesKeyByCurrency?.[stakingCurrency]?.collateralAvailable;

  const getMessage = () => {
    if (isQuoteCurrency && isCollateralAvailable)
      return (
        <FormattedMessage id='Assets.r251015.Staked_symbol_tradable_perpetual' values={{ symbol: stakingCurrency }} />
      );
    if (isQuoteCurrency && !isCollateralAvailable)
      return (
        <FormattedMessage
          id='Assets.r251015.Staked_symbol_tradable_isolated_margin'
          values={{ symbol: stakingCurrency }}
        />
      );
    if (!isQuoteCurrency)
      return (
        <FormattedMessage
          id='Assets.r251015.Staked_symbol_tradable_cross_margin'
          values={{ symbol: stakingCurrency }}
        />
      );
    return null;
  };
  return (
    <p
      className={center({
        display: !(isQuoteCurrency || isCollateralAvailable) ? 'none' : 'flex',
        mt: 24,
        textStyle: 'Text/M/Strong',
        gap: 4,
        color: 'content.default.level-4',
      })}
    >
      <InformationCircleIcon size={16} />
      {getMessage()}
    </p>
  );
};

export default StakingCurrencyTradabilityInfo;
